// extracted by mini-css-extract-plugin
module.exports = {"filterWrapper":"PlayerRankingsFilters_filterWrapper__KnIYe","uppercase":"PlayerRankingsFilters_uppercase__Ha2N9"};